import { useEffect, useState } from "react";
import { Clapperboard } from "lucide-react";
import { ReportBody } from "@/components/reports/ReportView";
import { rangeLabel } from "@/lib/reports";

export default function PublicReport({ token }) {
  const [rep, setRep] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/report/${token}`).then(async (r) => {
      if (!r.ok) throw new Error((await r.json()).detail || "Raportul nu e disponibil");
      setRep(await r.json());
    }).catch((e) => setErr(e.message));
  }, [token]);
  return (
    <div className="relative z-10 mx-auto max-w-4xl px-4 sm:px-8 py-10 space-y-6" data-testid="public-report">
      <div className="flex items-center gap-3"><span className="h-11 w-11 rounded-2xl bg-amber-500 flex items-center justify-center"><Clapperboard className="h-5 w-5 text-[#0B0D13]" /></span>
        <div><h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">Raport social media</h1>
          {rep && <p className="text-zinc-500" data-testid="public-report-range">{rep.scope_name || "Toți clienții"} · {rangeLabel(rep)}</p>}</div></div>
      {err && <p className="text-rose-500" data-testid="public-report-error">{err}</p>}
      {rep && <ReportBody rep={rep} photoOf={(r) => (r.client.photo ? `${process.env.REACT_APP_BACKEND_URL}${r.client.photo}` : "")} />}
    </div>
  );
}
